import { render, staticRenderFns } from "./ChoicesTaskSetup.vue?vue&type=template&id=3d56b633&scoped=true"
import script from "./ChoicesTaskSetup.vue?vue&type=script&lang=ts"
export * from "./ChoicesTaskSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d56b633",
  null
  
)

export default component.exports